var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.665 5.035 7.35 2.173a.452.452 0 0 0-.747.342v1.507c-3.025.035-5.424.641-5.424 3.508 0 1.158.745 2.304 1.57 2.903.256.187.623-.047.528-.35-.854-2.732.405-3.457 3.326-3.499V8.24c0 .39.457.592.747.342l3.315-2.863a.452.452 0 0 0 0-.684z",
    fill: "#323234"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.1f62209fb14a2ad986d724cfd6c2e5db.svg";
export { ForwardRef as ReactComponent };